import React, { useState, useEffect } from "react";
import { all_routes } from "../router/all_routes";
import Breadcrumb from "../../core/common/Breadcrumb/breadcrumb";
import Sidebar from "./sidebar/sidebar";
import axios from "axios";
import DriversSection from "./Drivers/DriversSection";

const AgentDrivers = () => {
  const routes = all_routes;
  const [user, setUser] = useState<any>(null);
  const [empresa, setEmpresa] = useState<any>(null);

  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const headers = { Authorization: `Bearer ${token}` };

    // Buscar o usuário
    axios
      .get(`${BASE_URL}/usuarios/me`, { headers })
      .then((res) => setUser(res.data))
      .catch((err) => console.error("Erro ao carregar usuário", err));

    // Buscar a empresa
    axios
      .get(`${BASE_URL}/empresas/minha`, { headers })
      .then((res) => setEmpresa(res.data))
      .catch((err) => console.error("Erro ao buscar empresa", err));
  }, []);

  const breadcrumbs = [
    { label: "Dashboard", link: routes.agentDashboard, active: false },
    { label: "Drivers", active: true },
  ];

  return (
    <div>
      <Breadcrumb title="Drivers" breadcrumbs={breadcrumbs} backgroundClass="breadcrumb-bg-04" />
      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-4">
              <Sidebar user={user} />
            </div>
            <div className="col-xl-9 col-lg-8">
              <div className="card settings mb-0">
                <div className="card-header">
                  <h6>Drivers Management</h6>
                </div>
                <div className="card-body pb-3">
                  {empresa && <DriversSection empresaId={empresa.id} />}
                </div>
                <div className="card-footer d-flex justify-content-end">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentDrivers;
